import { Button, Card } from '@/components/UI';

interface SupportRestrictedFeatureCardProps {
    title: string;
    description: string;
    backTo?: string;
    backLabel?: string;
}

const SupportRestrictedFeatureCard = ({
    title,
    description,
    backTo = '/user/portfolios',
    backLabel = 'Go to Portfolios'
}: SupportRestrictedFeatureCardProps) => {
    return (
        <div className="mx-auto w-full max-w-3xl px-4 py-8">
            <Card
                bodyClassName="space-y-5"
                subtitle="Read-only support sessions intentionally block a few high-risk workflows."
                title={title}
            >
                <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm leading-6 text-amber-100">
                    {description}
                </div>
                <p className="text-sm leading-6 text-zinc-400">
                    End the support session from the banner when you need to return to your normal admin account and use this workflow.
                </p>
                <div className="flex flex-col gap-3 sm:flex-row">
                    <Button to={backTo}>{backLabel}</Button>
                    <Button to="/" variant="outline-dark">
                        Return Home
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default SupportRestrictedFeatureCard;
